import request from '@/router/axios'

const base = '/api/produce/railway-unload-efficiency'

export const fetchKpi = (data) =>
  request({ url: `${base}/kpi`, method: 'post', data })

export const fetchDurationTrend = (data) =>
  request({ url: `${base}/durationTrend`, method: 'post', data })

export const fetchDelayReasonBars = (data) =>
  request({ url: `${base}/delayReasonBars`, method: 'post', data })

export const fetchShiftRanking = (data) =>
  request({ url: `${base}/shiftRanking`, method: 'post', data })

export const fetchDeviceCompare = (data) =>
  request({ url: `${base}/deviceCompare`, method: 'post', data })

export const fetchDetailPage = (data) =>
  request({ url: `${base}/detailPage`, method: 'post', data })

/** 班组下拉：与 produce 模块 typesetting/api.js getList 一致 */
export const fetchTeamOptions = (params) =>
  request({
    url: '/api/produce/produce-team/select/page',
    method: 'get',
    params: {
      page: 1,
      size: 500,
      ...params
    }
  })

export const fetchWagonDevicePage = (data) =>
  request({ url: '/api/produce/wagon-tippler-device/selectPage', method: 'post', data })

// 设备下拉（拼音码去重查询）
// 对应后端：/api/produce/base-device-manage/select/distinct/pycode?deviceName={{key}}
export const fetchDevicePycode = (params = {}) =>
  request({
    url: '/api/produce/base-device-manage/select/distinct/pycode',
    method: 'get',
    params
  })
